import styled from "styled-components";
import { colors } from "../../assets";

export const ModalWithChildrenContainer = styled.div`
  display: none;
  position: fixed;
  z-index: 999;
  background-color: ${colors["background-modal"]};
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;

  &.active {
    display: flex;
  }

  .modal-content-wrapper {
    background: #ffffff;
    border-radius: 3px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    padding: 20px 22px 40px 40px;
    width: ${({ width }) => width ? width : "620px"};
    max-width: ${({ maxWidth }) => maxWidth ? maxWidth : "620px"};
    max-height: 90vh;
    overflow: hidden;

    .modal-close {
      text-align: right;

      img {
        max-width: 18px;
        cursor: pointer;
      }
    }

    .modal {
      &-title {
        color: ${colors["PR-001-100"]};
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
      }
      &-icon-bg {
        display: inline-block;
        background: rgba(179, 202, 220, 0.3);
        width: 62px;
        min-width: 62px;
        height: 62px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          max-width: 34px;
        }
      }
      &-text {
      }
    }
  }
`;
